import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'
import _imports_1 from '@/assets/img/exclamation-triangle-fill-yellow.svg'


const _withScopeId = n => (_pushScopeId("data-v-6554c14d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "bannedProviderAlert" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.opensanctions.org/",
  target: "_blank",
  class: "fs_14 fw_700"
}, "https://www.opensanctions.org/", -1))
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { class: "col-sm-12" }
const _hoisted_15 = { class: "text-center mt-5" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Create a new provider",
          text: "Create a new provider"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_localized_text, {
              localizedKey: "Before proceeding, check if your provider is legitimate and not banned:",
              text: "Before proceeding, check if your provider is legitimate and not banned:",
              class: "fs_14 fw_700 mx-1"
            }),
            _hoisted_11
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_form_field, {
            type: "text",
            modelValue: _ctx.model.providerName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.providerName) = $event)),
            placeholderKey: "Provider Name",
            placeholderValue: "Provider Name",
            labelKey: "Provider Name*",
            labelValue: "Provider Name*"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_form_field, {
            type: "select",
            labelKey: "Country*",
            labelValue: "Country*",
            placeholderKey: "Select provider's company",
            placeholderValue: "Select provider's company",
            list: _ctx.countries,
            modelValue: _ctx.model.countryIdentifier,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.countryIdentifier) = $event)),
            required: true
          }, null, 8, ["list", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_form_field, {
            type: "text",
            labelKey: "Provider address",
            labelValue: "Provider address",
            placeholderKey: "Provider address",
            placeholderValue: "Provider address",
            modelValue: _ctx.model.address,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.address) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.model.providerName || !_ctx.model.countryIdentifier,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Create",
            text: "Create"
          })
        ], 8, _hoisted_16)
      ])
    ])
  ]))
}